import { useQueryParams } from '@ubeya/shared-web/hooks/useQueryParams';
import { getSafeRedirectUrl } from '../utils/redirectUrl';

const WEB_URL = process.env.WEB_URL;
const CREW_URL = process.env.CREW_URL;

const useRedirectUrl = () => {
  const { redirectUrl: redirectUrlParams } = useQueryParams();

  const redirectUrl = getSafeRedirectUrl(redirectUrlParams, WEB_URL);

  return {
    webRedirectUrl: redirectUrl || WEB_URL,
    crewRedirectUrl: redirectUrl || CREW_URL
  };
};

export default useRedirectUrl;
